// extracted by mini-css-extract-plugin
module.exports = {"body":"Body_body__3TL0o","semi-bold":"Body_semi-bold__tsfY2"};